
import { Component, Vue } from 'vue-property-decorator';
import { DeviceInfo } from '@/types/device-info';
import { State } from 'vuex-class';
import { UserInfo } from '@/types/user-info';
import PaymentInvoicePopup from '@/components/users/popups/PaymentInvoicePopup.vue';
import api from '@/modules/api';
import { mutations } from '@/store/types';
import { unixToReadableDate } from '@/utils/datetime';
import { centsToUsd } from '@/utils/amount';
import { PaymentUser } from '@/types/payment';
import PaymentCardModal from '@/components/devices/popups/PaymentCardModal.vue';
import { getMonthNameByNumber } from '@/utils/datetime';
import * as dlg from '@/modules/dlg';
import { getCurrencySymbol } from '@/utils/currency';
import { getErrorMessage } from '@/utils/common';
import { defaultCurrency } from '@/constants/currency';

@Component({
    components: {
        PaymentInvoicePopup,
        PaymentCardModal,
    },
})
export default class UserPaymentSettings extends Vue {
    tableLoading = false;
    paymentHistory: any = [];
    invoiceDetail = null;

    hasMore = false;
    protected limit = 10;
    currentPage = 1;
    protected starting_after = '';
    protected ending_before = '';
    paymentMethods: any[] = [];
    stripePaymentUser: PaymentUser | null = null;
    defaultCurrency = defaultCurrency;
    getCurrencySymbol = getCurrencySymbol;

    // Stripe payment
    paymentCardModal = false;

    getMonthNameByNumber = getMonthNameByNumber;

    @State('user')
    user!: UserInfo;

    @State('device')
    device!: DeviceInfo;

    showPaymentInvoiceModal = false;
    unixToReadableDate = unixToReadableDate;
    centsToUsd = centsToUsd;

    mounted() {
        this.getPaymentCustomer();
        this.getPaymentHistory();
    }

    async nextPage() {
        const dataLength = this.paymentHistory.length;
        if (dataLength > 0) {
            this.starting_after = this.paymentHistory[dataLength - 1].id;
            this.ending_before = '';
            await this.getPaymentHistory();
            this.currentPage += 1;
        }
    }

    async prevPage() {
        const dataLength = this.paymentHistory.length;
        if (dataLength > 0) {
            this.starting_after = '';
            this.ending_before = this.paymentHistory[0].id;
            await this.getPaymentHistory();
            this.currentPage -= 1;
            this.hasMore = true;
        }
    }

    async getPaymentHistory() {
        this.tableLoading = true;
        try {
            const history = await api.getPaymentHistory(this.limit, this.starting_after, this.ending_before);
            this.paymentHistory = history.data.data ?? [];
            this.hasMore = history.data.has_more ?? false;
        } catch (error) {
            Vue.toasted.error(getErrorMessage(error));
        } finally {
            this.tableLoading = false;
        }
    }

    async viewInvoice(invoiceId: string) {
        if (!invoiceId) return;
        this.$store.commit(mutations.LOADING, { loading: true });
        try {
            const invoice = await api.getInvoiceDetails(invoiceId);
            this.invoiceDetail = invoice.data ?? null;
            this.showPaymentInvoiceModal = true;
        } catch (error) {
            Vue.toasted.error(getErrorMessage(error));
        } finally {
            this.$store.commit(mutations.LOADING, { loading: false });
        }
    }

    // stripe
    async getPaymentCustomer() {
        try {
            const paymentUser = await api.getPaymentUser();
            this.stripePaymentUser = paymentUser.paymentUser ?? null;
            this.paymentMethods = paymentUser.paymentMethods ?? [];
        } catch (error) {
            Vue.toasted.error(getErrorMessage(error));
        }
    }
    addPaymentMethod() {
        this.paymentCardModal = true;
    }
    async onPaymentDetailSubmit() {
        this.paymentCardModal = false;

        // refresh payment user
        // await this.getPaymentCustomer();
    }
    async onPaymentMethodRemove(cardId: any) {
        const confirmed = await dlg.confirm('Are you sure you want to remove payment method', 'Remove payment method');
        if (!confirmed) return;
        this.$store.commit(mutations.LOADING, { loading: true });
        try {
            await api.removePaymentMethod(cardId);
            // refresh payment user
            await this.getPaymentCustomer();
            Vue.toasted.success(`Removed successfully`);
        } catch (error) {
            Vue.toasted.error(getErrorMessage(error));
        } finally {
            this.$store.commit(mutations.LOADING, { loading: false });
        }
    }
    // stripe
}
